import { memo, useMemo } from 'react';

import useMedias from '@Hooks/useMedias';
import Column from '../Column';

import type { Parameter } from '@Pages/PageProduct';
import type { FC, HTMLAttributes } from 'react';

export interface ColumnsProps extends HTMLAttributes<HTMLDivElement> {
  className?: string;
  parameters: readonly Parameter[];
}

const Columns: FC<ColumnsProps> = (props) => {
  const { parameters, ...restProps } = props;
  const { isDesktopM } = useMedias();

  const columns = useMemo(() => {
    if (!isDesktopM) {
      const size = Math.ceil(parameters.length / 3);

      return [
        parameters.slice(0, size),
        parameters.slice(size, 2 * size),
        parameters.slice(2 * size),
      ];
    }

    const to = Math.ceil(parameters.length / 2);
    return [parameters.slice(0, to), parameters.slice(to)];
  }, [parameters, isDesktopM]);

  return (
    <div {...restProps}>
      {columns.map((column, index) => (
        <Column key={index} parameters={column} />
      ))}
    </div>
  );
};

export default memo(Columns);
